import React from 'react';
import './RedditButton.css';

// Reddit SVG icon component using the branded logo
const RedditIcon = ({ className }) => (
    <svg 
        className={className}
        viewBox="0 0 256 256" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <radialGradient id="radial-gradient" cx="1092.28" cy="474.7" fy="465.57119594491735" r="127.45" gradientTransform="translate(-312.36 -87.07) scale(0.47 0.41)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#ffffff"/>
                <stop offset="0.4" stopColor="#ffffff"/>
                <stop offset="0.51" stopColor="#f9fcfc"/>
                <stop offset="0.62" stopColor="#edf3f5"/>
                <stop offset="0.7" stopColor="#dee9ec"/>
                <stop offset="0.72" stopColor="#d8e4e8"/>
                <stop offset="0.76" stopColor="#ccd8df"/>
                <stop offset="0.8" stopColor="#c8d5dd"/>
                <stop offset="0.83" stopColor="#ccd6de"/>
                <stop offset="0.85" stopColor="#d8dbe2"/>
                <stop offset="0.88" stopColor="#ede3e9"/>
                <stop offset="0.9" stopColor="#ffebef"/>
            </radialGradient>
            <radialGradient id="radial-gradient-2" cx="783.51" cy="474.7" r="127.45" xlinkHref="#radial-gradient"/>
            <radialGradient id="radial-gradient-3" cx="941.93" cy="730.17" fy="730.1693366031468" r="384.44" gradientTransform="translate(-312.36 -141.78) scale(0.47 0.33)" xlinkHref="#radial-gradient"/>
            <radialGradient id="radial-gradient-4" cx="-2854.51" cy="112.56" r="32.12" gradientTransform="translate(-1067.34 434.64) rotate(180) scale(0.47 0.69)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#f60"/>
                <stop offset="0.5" stopColor="#ff4500"/>
                <stop offset="0.7" stopColor="#fc4301"/>
                <stop offset="0.82" stopColor="#f43f07"/>
                <stop offset="0.92" stopColor="#e53812"/>
                <stop offset="1" stopColor="#d4301f"/>
            </radialGradient>
            <radialGradient id="radial-gradient-5" cx="856.49" cy="112.56" r="32.12" gradientTransform="matrix(0.47, 0, 0, -0.69, -203.36, 434.64)" xlinkHref="#radial-gradient-4"/>
            <radialGradient id="radial-gradient-6" cx="937.72" cy="1023.54" r="113.26" gradientTransform="translate(-203.36 83.61) scale(0.47 0.31)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#172e35"/>
                <stop offset="0.29" stopColor="#0e1c21"/>
                <stop offset="0.73" stopColor="#030708"/>
                <stop offset="1"/>
            </radialGradient>
            <radialGradient id="radial-gradient-7" cx="1037.6" cy="183.35" fy="183.3534334270371" r="99.42" gradientTransform="translate(-312.36 -52.07) scale(0.47)" xlinkHref="#radial-gradient"/>
            <radialGradient id="radial-gradient-8" cx="996.17" cy="283.69" r="81.49" gradientTransform="translate(-203.36 157.71) scale(0.47)" gradientUnits="userSpaceOnUse">
                <stop offset="0.48" stopColor="#7a9299"/>
                <stop offset="0.67" stopColor="#172e35"/>
                <stop offset="0.75"/>
                <stop offset="0.82" stopColor="#172e35"/>
            </radialGradient>
        </defs>
        {/* Main orange background bubble - keep Reddit orange */}
        <path d="M237,206h0A128,128,0,0,0,109,334h0a127.23,127.23,0,0,0,37.5,90.5l-24.4,24.4a7.68,7.68,0,0,0,5.4,13.1H237A128,128,0,0,0,365,334h0A128,128,0,0,0,237,206Z" transform="translate(-109 -206)" fill="#FF4500"/>
        {/* Reddit mascot details */}
        <circle cx="200.6" cy="123.7" r="29.9" fill="url(#radial-gradient)"/>
        <circle cx="55.4" cy="123.7" r="29.9" fill="url(#radial-gradient-2)"/>
        <ellipse cx="128.1" cy="149.3" rx="85.3" ry="64" fill="url(#radial-gradient-3)"/>
        <path d="M211.8,349.1c-.5,10.8-7.7,14.8-16.1,14.8s-14.8-5.6-14.3-16.4,7.7-18,16.1-18S212.3,338.3,211.8,349.1Z" transform="translate(-109 -206)" fill="#842123"/>
        <path d="M292.6,347.5c.5,10.8-5.9,16.4-14.3,16.4s-15.6-3.9-16.1-14.8,5.9-19.6,14.3-19.6,15.6,7.1,16.1,18Z" transform="translate(-109 -206)" fill="#842123"/>
        <path d="M262.3,350.1c.5,10.1,7.2,13.8,15,13.8s13.8-5.5,13.4-15.7-7.2-16.8-15-16.8S261.8,339.9,262.3,350.1Z" transform="translate(-109 -206)" fill="url(#radial-gradient-4)"/>
        <path d="M211.8,350.1c-.5,10.1-7.2,13.8-15,13.8s-13.8-5.5-13.3-15.7,7.2-16.8,15-16.8S212.3,339.9,211.8,350.1Z" transform="translate(-109 -206)" fill="url(#radial-gradient-5)"/>
        <path d="M237.1,371.1c-10.6,0-20.7.5-30.1,1.4a2.37,2.37,0,0,0-2,3.2,35,35,0,0,0,64.2,0,2.31,2.31,0,0,0-2-3.2C257.8,371.6,247.7,371.1,237.1,371.1Z" transform="translate(-109 -206)" fill="#bbcfda"/>
        <path d="M237.1,373.5a282.67,282.67,0,0,0-30,1.5,2.42,2.42,0,0,0-2,3.3,34.69,34.69,0,0,0,64,0,2.42,2.42,0,0,0-2-3.3,285.43,285.43,0,0,0-30-1.5Z" transform="translate(-109 -206)" fill="#fff"/>
        <path d="M237.1,372.2c-10.4,0-20.3.5-29.5,1.4a2.37,2.37,0,0,0-2,3.2,34.13,34.13,0,0,0,63,0,2.31,2.31,0,0,0-2-3.2C257.4,372.8,247.5,372.2,237.1,372.2Z" transform="translate(-109 -206)" fill="url(#radial-gradient-6)"/>
        <circle cx="174.8" cy="55.5" r="21.2" fill="url(#radial-gradient-7)"/>
        <path d="M236.8,294c-2.5,0-4.6-1.1-4.6-2.7a34.4,34.4,0,0,1,34.4-34.4,4.6,4.6,0,1,1,0,9.2,25.22,25.22,0,0,0-25.2,25.2C241.4,293,239.3,294,236.8,294Z" transform="translate(-109 -206)" fill="url(#radial-gradient-8)"/>
        <path d="M206.3,355.1c0,3.9-4.2,5.7-9.3,5.7s-9.3-1.8-9.3-5.7,4.2-7.1,9.3-7.1S206.3,351.1,206.3,355.1Z" transform="translate(-109 -206)" fill="#ff6101"/>
        <path d="M286.5,355.1c0,3.9-4.2,5.7-9.3,5.7s-9.3-1.8-9.3-5.7,4.2-7.1,9.3-7.1S286.5,351.1,286.5,355.1Z" transform="translate(-109 -206)" fill="#ff6101"/>
        <ellipse cx="94.4" cy="134.8" rx="3.3" ry="3.6" fill="#ffc49c"/>
        <ellipse cx="173.3" cy="134.8" rx="3.3" ry="3.6" fill="#ffc49c"/>
    </svg>
);

const RedditButton = ({ 
    className = '', 
    variant = 'default', 
    onClick = null,
    children = 'Reddit',
    href = 'https://www.reddit.com/r/mythicmapsai/'
}) => {
    const classes = `reddit-button ${variant === 'navbar' ? 'navbar-reddit' : ''} ${className}`;
    
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    
    return (
        <a 
            href={href}
            target="_blank" 
            rel="noopener noreferrer" 
            className={classes}
            onClick={handleClick}
        >
            <RedditIcon className="reddit-icon" />
            {children}
        </a>
    );
};

export default RedditButton; 